<script>
export default {
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-NMMD4VT27R';
    script.async = true;
    document.head.appendChild(script);

    const gtagScript = document.createElement('script');
    gtagScript.type = 'application/javascript';
    gtagScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-NMMD4VT27R');
    `;
    document.head.appendChild(gtagScript);
  },
};
</script>
